<template>
    <div
        class="uik-data-label"
        :class="`uik-data-label--${size}`"
    >
        <div
            v-if="color"
            class="uik-data-label__color"
            :class="[
                (`uik-data-label__color--${color}`),
                {'uik-data-label__color--fill': fill}
            ]"
        />
        <div
            v-if="text"
            class="uik-data-label__text"
            :title="text"
        >{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: "UikDataLabel",
    props: {
        /**
         * Displayed text
         */
        text: {
            type: String,
            default: ""
        },
        /**
         * Label color
         */
        color: {
            type: String,
            default: "primary",
            validator (value) {
                return [
                    "primary",
                    "secondary",
                    "success",
                    "warning",
                    "error",
                    "red",
                    "orange",
                    "yellow",
                    "lime",
                    "green",
                    "cyan",
                    "blue",
                    "purple",
                    "pink",
                    "gray"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Is color indicator filled or bordered - circle/ring
         */
        fill: {
            type: Boolean,
            default: false
        },
        /**
         * Label size
         */
        size: {
            type: String,
            default: "regular",
            validator (value) {
                return [
                    "regular",
                    "small"
                ].indexOf(value) !== -1
            }
        }
    }
}
</script>

<style lang="scss">
.uik-data-label {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;

    .uik-data-label__color {
        border-radius: 50%;
        border: solid 2px transparent;

        & + .uik-data-label__text {
            margin-left: 8px;
        }

        @each $name, $color in $colors {
            &--#{"" + $name} {
                border-color: $color;

                &.uik-data-label__color--fill {
                    border-color: transparent;
                    background: $color;
                }
            }
        }

        @each $name, $color in $projectColors {
            &--#{"" + $name} {
                border-color: $color;

                &.uik-data-label__color--fill {
                    border-color: transparent;
                    background: $color;
                }
            }
        }
    }

    .uik-data-label__text {
        color: $textMain;
    }

    &--regular {
        .uik-data-label__color {
            $size: 10px;
            width: $size;
            min-width: $size;
            height: $size;
        }

        .uik-data-label__text {
            font-size: 14px;
            line-height: 16px;
        }
    }

    &--small {
        .uik-data-label__color {
            $size: 7px;
            width: $size;
            min-width: $size;
            height: $size;
        }

        .uik-data-label__text {
            font-size: 13px;
            line-height: 15px;
        }
    }
}
</style>
